<div class="inactivity-modal">
  <h2 class="bold">{{ data.title }}</h2>
  <p>{{ data.message }}</p>
  <div class="actions">
    <button mat-raised-button color="primary" (click)="goToLogin()">{{ data.buttonText }}</button>
  </div>
</div>